import React from "react";

export const CoFounder = () => {
  return (
    <div className="cofounder ">
      <div className="container">
        {/* <div className="text-center mb-5"> */}
        {/* <button className="btn-gradient mb-3">Testimonial!</button> */}
        {/* <div className="text-center d-flex align-items-center justify-content-center">
            <h2 className="text-gradient">Meet the Investors</h2>
          </div> */}
        {/* </div> */}

        <div className="testimonial-wrapper">
          <div className="testimonial-content">
            <div className="quote-icon mb-4">
              <svg
                width="40"
                height="40"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.028 6C6.684 11.184 2 19.68 2 27.48C2 35.52 6.924 41 13.788 41C19.692 41 24.376 36.72 24.376 31.24C24.376 25.764 20.172 21.964 14.988 21.964C14.028 21.964 12.828 22.204 12.348 22.444C13.068 17.924 17.532 12.684 22.456 10.04L14.028 6ZM37.652 6C30.308 11.184 25.624 19.68 25.624 27.48C25.624 35.52 30.548 41 37.412 41C43.316 41 48 36.72 48 31.24C48 25.764 43.796 21.964 38.612 21.964C37.652 21.964 36.452 22.204 35.972 22.444C36.692 17.924 41.156 12.684 46.08 10.04L37.652 6Z"
                  fill="url(#paint0_linear)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear"
                    x1="2"
                    y1="23.5"
                    x2="48"
                    y2="23.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#8A2BE2" />
                    <stop offset="1" stopColor="#FF69B4" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <p className="testimonial-text">
              "Stabolut’s USB is what the DeFi industry has been looking for: a decentralized, transparent and yield-bearing stablecoin."
            </p>

            <div className="testimonial-author">
              {/* <div className="author-image">
                <img src="/images/Frederic Fernandez.png" alt="Frederic" />
              </div> */}
              <div className="author-info">
                <h3 className="" >Frederic Fernandez</h3>
                <p>Co-Founder</p>
                <div className="company-logo text-center">
                  <a href="http://www.dextools.io">
                    <img
                      src="/images/dextools_logo_full_dark 1.png"
                      alt="dextools_logo_full_dark"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
